// src/tests/ChildTest/NonwordRepetition/TrialNonwords.js
import React, {Component} from 'react';
import strings from '../../strings';
import listen from '../../assets/listen.png';
import {updateStepData} from '../../api';
import {OBJECT_IMAGE_MAP, SHAPE_IMAGE_MAP} from './assets';

import {getChildTrialPack, noDistractionsSounds} from './assets';
import './styles.scss';
import AudioPlayer from '../../components/AudioPlayer';

// Helper to get random int inclusive
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

class TrialNonwords extends Component {
	constructor(props) {
		super(props);
		const langCode = strings.getLanguage();
		const {testKeyType} = this.props;
		this.trials = getChildTrialPack(langCode, testKeyType);
		this.distractionVoiceOvers =
			langCode === 'nn' ? noDistractionsSounds : noDistractionsSounds;
		this.state = {
			isInDelay: false, // true during 15s distraction window
			distraction: null, // { type, ...payload }
			isPlayingAudio: false,
		};

		this.sayAgainTimeout = null;
	}

	componentDidMount() {
		this.initializeAudio();
	}

	componentWillUnmount() {
		this.stopAll();
		clearTimeout(this.sayAgainTimeout);
	}

	componentDidUpdate(prevProps) {
		// If step index changes (3 trial items), restart stimulus
		if (prevProps.currentStep !== this.props.currentStep) {
			this.startNewTask();
		}

		const prevSD = prevProps.stepData || {};
		const nextSD = this.props.stepData || {};

		// When admin has just coded the trial (answered toggles false -> true)

		if (nextSD.answered && !prevSD.answered) {
			this.playFeedback(nextSD.correct, nextSD.reason);
		}

		// When admin has just scored the *immediate* repetition (same flag as Test)
		if (nextSD.nonwordImmediateDone && !prevSD.nonwordImmediateDone) {
			this.scheduleDelayedCue();
		}
	}
	getCurrentTrial = () => {
		const index = this.props.currentStep || 0;
		return this.trials[index];
	};
	initializeAudio = () => {
		this.trials.forEach((trial) => {
			Object.values(trial).forEach((a) => a && a.load && a.load());
		});

		setTimeout(() => this.startNewTask(), 500);
	};

	startNewTask = () => {
		this.stopAll();
		clearTimeout(this.sayAgainTimeout);

		updateStepData({nonwordImmediateDone: false});

		this.setState({
			isInDelay: false,
			distraction: null,
		});

		const trial = this.getCurrentTrial();
		if (!trial) return;

		const {stimulus} = trial;
		if (!stimulus) return;

		if (stimulus.play) {
			this.setState({isPlayingAudio: true});

			if (stimulus.once) {
				stimulus.once('end', () => {
					this.setState({isPlayingAudio: false});
				});
			}

			stimulus.play();
		}
	};

	// ---------- distraction generation (same logic as Test, but simpler sequence) ----------
	getDistractionTypeForStep = (stepIndex) => {
		const seq = ['CLAP_COUNT', 'COLOR_CIRCLES'];

		return seq[stepIndex];
	};
	createRandomDistraction = (stepIndex) => {
		const {testKeyType, ageGroup: ag} = this.props || {};

		const tk = String(testKeyType || '').toUpperCase();

		const isYA =
			tk.includes('Y/A') ||
			tk.includes('YOUTH') ||
			tk.includes('UNGDOM') ||
			tk.includes('ADULT') ||
			tk.includes('VOKSEN') ||
			tk.includes('YA');

		const type = this.getDistractionTypeForStep(stepIndex);

		switch (type) {
			case 'CLAP_COUNT': {
				const n = isYA ? randInt(10, 13) : randInt(8, 12);
				return {type, n};
			}

			case 'COLOR_CIRCLES': {
				const colors = [
					'red',
					'green',
					'blue',
					'yellow',
					'purple',
					'orange',
					'pink',
					'brown',
					'black',
				];
				const count = isYA ? randInt(20, 25) : randInt(4, 6);
				const chosen = Array.from({length: count}, () => {
					return colors[randInt(0, colors.length - 1)];
				});
				return {type, colors: chosen};
			}
			case 'NUMBER_LIST': {
				let min, max;
				const isChild_2_4 =
					(tk.includes('C') ||
						tk.includes('Child') ||
						tk.includes('Barn')) &&
					(ag === 2 || ag === 3 || ag === 4);
				const isChild_5_7 =
					(tk.includes('C') ||
						tk.includes('Child') ||
						tk.includes('Barn')) &&
					(ag === 5 || ag === 6 || ag === 7);
				const isYouth =
					tk.includes('Y') ||
					tk.includes('YOUTH') ||
					tk.includes('UNGDOM');
				const isAdult =
					tk.includes('A') ||
					tk.includes('ADULT') ||
					tk.includes('VOKSEN');
				if (isChild_2_4) {
					// Dysmate C (2.–4. grade)
					min = 11;
					max = 99;
				} else if (isChild_5_7) {
					// Dysmate C (5.–7. grade)
					min = 1000;
					max = 9999;
				} else if (isYouth) {
					// Dysmate Y
					min = 10000;
					max = 999999;
				} else if (isAdult) {
					// Dysmate A
					min = 100000;
					max = 999999;
				} else {
					// fallback
					min = 1;
					max = 100;
				}

				// NEW: Only ONE number
				const num = randInt(min, max);

				return {type, numbers: [num]};
			}

			case 'SAME_COLOR': {
				const colors = [
					'red',
					'green',
					'blue',
					'yellow',
					'brown',
					'orange',
				];
				const color = colors[randInt(0, colors.length - 1)];
				return {type, color};
			}

			case 'NAME_ANIMALS':
				return {type};

			case 'NAME_OBJECTS': {
				const allLabels = Object.keys(OBJECT_IMAGE_MAP);
				const minCount = isYA ? 6 : 4;
				const maxCount = isYA ? 8 : 6;
				const count = randInt(minCount, maxCount);

				const items = [];
				while (
					items.length < count &&
					items.length < allLabels.length
				) {
					const idx = randInt(0, allLabels.length - 1);
					const label = allLabels[idx];
					if (!items.includes(label)) items.push(label);
				}
				return {type, items};
			}

			case 'SIZE_ORDER': {
				const allLabels = Object.keys(OBJECT_IMAGE_MAP);
				const count = randInt(3, Math.min(6, allLabels.length));

				const chosen = [];
				while (chosen.length < count) {
					const idx = randInt(0, allLabels.length - 1);
					const label = allLabels[idx];
					if (!chosen.includes(label)) chosen.push(label);
				}

				// Unique size ranks
				// Unique size ranks = exactly count items
				const sizeRanks = Array.from(
					{length: count},
					(_, i) => i + 1
				).sort(() => Math.random() - 0.5);

				const items = chosen.map((label, i) => ({
					label,
					sizeRank: sizeRanks[i], // always valid now
				}));

				return {type, items};
			}

			case 'SHAPE_ANALOGY': {
				const shapes = Object.keys(SHAPE_IMAGE_MAP); // ['triangle','square','circle']
				const shape = shapes[randInt(0, shapes.length - 1)];
				return {type, shape};
			}

			default:
				return {type: 'NAME_ANIMALS'};
		}
	};

	scheduleDelayedCue = () => {
		clearTimeout(this.sayAgainTimeout);
		const stepIndex = this.props.currentStep || 0;
		const distraction = this.createRandomDistraction(stepIndex);

		this.setState({
			isInDelay: true,
			distraction,
		});

		// Run distraction for 15 seconds, then play trial "say it again"
		this.sayAgainTimeout = setTimeout(() => {
			this.setState({isInDelay: false, distraction: null});

			const trial = this.getCurrentTrial();
			const {sayAgain} = trial || {};
			if (sayAgain && sayAgain.play) {
				this.setState({isPlayingAudio: true});
				if (sayAgain.once) {
					sayAgain.once('end', () => {
						this.setState({isPlayingAudio: false});
					});
				}
				sayAgain.play();
			}
		}, 10000);
	};

	// ---------- feedback & stop ----------

	playFeedback = (isCorrect, reason) => {
		// Stop stimuli + any previous feedback
		this.stopAll();
		clearTimeout(this.sayAgainTimeout);

		const trial = this.getCurrentTrial();
		const {correct, wrong, noAnswer10s, wrong10s} = trial || {};

		let clip = null;

		if (isCorrect === true) {
			clip = correct || wrong;
		} else {
			if (reason === 'noAnswer10s' && noAnswer10s) {
				clip = noAnswer10s;
			} else if (reason === 'wrong10s' && wrong10s) {
				clip = wrong10s;
			} else {
				clip = wrong;
			}
		}
		console.log('clip is', clip);
		if (!clip || !clip.play) {
			setTimeout(() => updateStepData({feedbackDone: true}), 800);
			return;
		}

		clip.once('end', () => {
			setTimeout(() => updateStepData({feedbackDone: true}), 400);
		});
		clip.play();
	};

	stopAll = () => {
		const stop = (s) => {
			if (!s) return;
			if (s.stop) s.stop();
			else if (s.pause) s.pause();
		};

		this.trials.forEach((trial) => {
			Object.values(trial).forEach(stop);
		});

		this.setState({isPlayingAudio: false});
	};

	// ---------- render helpers (reuse same CSS as Test) ----------

	renderDistraction = () => {
		const {distraction} = this.state;
		if (!distraction) return null;

		switch (distraction.type) {
			case 'CLAP_COUNT':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction1}
							/>
						</p>
						<div className="nw-distraction__big-number">
							{distraction.n}
						</div>
					</div>
				);

			case 'COLOR_CIRCLES':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction2}
							/>
						</p>
						<div className="nw-distraction__circles">
							{distraction.colors.map((c) => (
								<div
									key={c}
									className="nw-distraction__circle"
									style={{backgroundColor: c}}
								/>
							))}
						</div>
					</div>
				);

			case 'NUMBER_LIST':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction3}
							/>
						</p>
						<div className="nw-distraction__numbers">
							{distraction.numbers.map((n) => (
								<span
									key={n}
									className="nw-distraction__number"
								>
									{n}
								</span>
							))}
						</div>
					</div>
				);

			case 'SAME_COLOR':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction6}
							/>
						</p>
						<div
							className="nw-distraction__color-block"
							style={{backgroundColor: distraction.color}}
						/>
					</div>
				);

			case 'NAME_OBJECTS':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction7}
							/>
						</p>
						<div className="nw-distraction__objects nw-distraction__objects--images">
							{distraction.items.map((label, idx) => {
								const src = OBJECT_IMAGE_MAP[label];
								if (!src) return null; // should not happen anymore
								return (
									<div
										key={`${label}-${idx}`}
										className="nw-distraction__object-imageWrapper"
									>
										<img
											src={src}
											alt={label}
											className="nw-distraction__object-image"
										/>
									</div>
								);
							})}
						</div>
					</div>
				);

			case 'SIZE_ORDER':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction8}
							/>
						</p>
						<div className="nw-distraction__objects nw-distraction__objects--images">
							{distraction.items.map((item, idx) => {
								const src = OBJECT_IMAGE_MAP[item.label];
								if (!src) return null;

								const size = 50 + item.sizeRank * 20; // random sizes (from unique sizeRank)

								return (
									<img
										key={`${item.label}-${idx}`}
										src={src}
										alt={item.label}
										style={{
											width: `${size}px`,
											height: `${size}px`,
											objectFit: 'contain',
											borderRadius: '12px',
										}}
									/>
								);
							})}
						</div>
					</div>
				);

			case 'SHAPE_ANALOGY':
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction4}
							/>
						</p>
						<div className="nw-distraction__shape-wrapper">
							{(() => {
								const src = SHAPE_IMAGE_MAP[distraction.shape];
								if (!src) return null;
								return (
									<img
										src={src}
										alt={distraction.shape}
										className="nw-distraction__shape-image"
									/>
								);
							})()}
						</div>
					</div>
				);

			case 'NAME_ANIMALS':
			default:
				return (
					<div className="nw-distraction">
						<p className="nw-distraction-audio">
							<AudioPlayer
								autoplay
								inline
								src={this.distractionVoiceOvers.distraction5}
							/>
							{strings.nonword_distr_animals ||
								'Nevn fire dyr så raskt du klarer.'}
						</p>
					</div>
				);
		}
	};

	render() {
		const {isInDelay, isPlayingAudio} = this.state;

		return (
			<div className="NonwordRepetition">
				{isPlayingAudio && (
					<>
						<img className="listen-image" src={listen} alt="" />
					</>
				)}
				{!isInDelay && <p></p>}

				{isInDelay && this.renderDistraction()}
			</div>
		);
	}
}

export default TrialNonwords;
